import { MinMaxFilter } from '@appTypes/FilterTypes';
import { ErrorWrapper } from '@components/style';
import { FC, useState } from 'react';
import styled from 'styled-components';
import NumericInputField from './numeric-input-field/NumericinputField';

type MinMaxDropdownOptionProps = {
  minPossibleValue?: number;
  maxPossibleValue?: number;
  min: number;
  max: number;
  valueChangeAction: (filter: MinMaxFilter<number>) => void;
  enterKeyAction: () => void;
  cssClass?: string;
  maxLength?: number;
  inputType?: string;
};

const MinMaxDropdownOption: FC<MinMaxDropdownOptionProps> = ({
  minPossibleValue,
  maxPossibleValue,
  min,
  max,
  cssClass,
  maxLength,
  inputType,
  valueChangeAction,
  enterKeyAction,
}) => {
  const [hasMinError, setHasMinError] = useState<boolean>(false);
  const [hasMaxError, setHasMaxError] = useState<boolean>(false);

  const handleMinInput = (value: number) => handleInput('min', value);
  const handleMaxInput = (value: number) => handleInput('max', value);

  const handleInput = (type: 'min' | 'max', value: number) => {
    if (type === 'min') {
      valueChangeAction({ min: value, max: max });
    }
    if (type === 'max') {
      valueChangeAction({ min: min, max: value });
    }
  };

  const handleMinMaxError = (type: 'min' | 'max', value: boolean): void => {
    if (type === 'min') {
      setHasMinError(value);
    } else if (type === 'max') {
      setHasMaxError(value);
    }
  };
  return (
    <>
      {(hasMinError || hasMaxError) && (
        <ErrorWrapper data-testid='range-error' marginTop={8}>
          Invalid Range
        </ErrorWrapper>
      )}
      <Wrapper data-testid='min-max-dropdown-option'>
        <NumericInputField
          value={min}
          minPossibleValue={minPossibleValue}
          maxPossibleValue={max}
          handleInput={handleMinInput}
          handleError={(value: boolean) => handleMinMaxError('min', value)}
          label='Min'
          isAutoFocussed={true}
          maxLength={maxLength}
          cssClass={cssClass}
          inputType={inputType}
          handleKey={enterKeyAction}
        />
        <NumericInputField
          value={max}
          minPossibleValue={Math.max(minPossibleValue, min)}
          handleInput={handleMaxInput}
          handleError={(value: boolean) => handleMinMaxError('max', value)}
          label='Max'
          maxLength={maxLength}
          cssClass={cssClass}
          inputType={inputType}
          handleKey={enterKeyAction}
        />
      </Wrapper>
    </>
  );
};

export default MinMaxDropdownOption;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 20px 20px 20px;
  & input {
    width: 80px;
  }
`;
